import genres from './genres.json';
import instruments from './instruments.json';

export const GenreTagDictionary: Record<string, string> = genres;
export const InstrumentTagDictionary: Record<string, string> = instruments;
